import {
    dispatchRefreshEventFormattingDetails,
    updateSpan,
    updateIdentityLookup,
    getAllTheSpans,
    getMinMaxSpans,
    getAllTheSpansMinMax
} from './RefreshFunctions'
import { createContext } from 'react'

export const spanPickerType = 'drilling-operations-span-picker'

export const runTypeOptions = [
    {
        value: 'casing',
        label: 'casing'
    },
    {
        value: 'drilling',
        label: 'drilling'
    },
    { value: 'non_tubular', label: 'non_tubular' }
]

export const initialRunReferenceState: runReferenceProps = {
    interventionId: 0,
    sectionId: 0,
    runId: 0,
    drillingSectionPosIndex: 0,
    runPosIndex: 0
}

export const initialOperationState: operationNodesTypes = {
    title: '',
    key: '',
    operation: '',
    runReference: initialRunReferenceState
}

export const initialRunState: runDataTypes = {
    title: '',
    key: '',
    label: '',
    runReference: initialRunReferenceState,
    children: []
}

export const initialCheckState: TreeCheckingProps = {
    mainCheck: {
        status: false,
        setStatus: () => console.log('setStatus on mainCheck'),
        indeterminate: false,
        onChange: () => console.log('onChange on mainCheck')
    },
    checkedKeys: [],
    onCheck: () => console.log('onCheck on check'),
    individualTimespans: false,
    timestampOption: 'minMax',
    setIndividualTimespans: () => console.log('setIndividualTimespans on check'),
    qtyOfCheckedOperations: 0
}

export const colors = [
    '#4998bf',
    '#3cc137',
    '#a9eb39',
    '#bc3965',
    '#62c3cc',
    '#c38eb1',
    '#db3c92',
    '#9be57c',
    '#9262a1',
    '#904c5b',
    '#5c68b3',
    '#e24bc8',
    '#75982a',
    '#ac3692',
    '#3a6f54',
    '#8eb66c',
    '#69e2ac',
    '#c883e2',
    '#80c43b',
    '#a24a79',
    '#c7df37',
    '#db7a8c',
    '#45a047',
    '#7272e1',
    '#8fbddf',
    '#cdade1',
    '#8448a5',
    '#51a67e',
    '#427480',
    '#58e487',
    '#e37dbb',
    '#6d98e2',
    '#cce374',
    '#ea397a',
    '#4f712d',
    '#c65ee7',
    '#6ae3d5',
    '#65ec4a',
    '#73597b',
    '#e0e665'
]

export const defaultConfigs: OperationsPickerConfigsProps = {
    autoLoadsLastRun: false,
    autoLoadsLastRunTillNow: false,
    enableChecking: true,
    updateDashboardSpan: true,
    autoSelectLastRun: true,
    autoCheck: 'lastSection',
    autoCheckByRunType: false,
    timespanDefaultOption: 'minMax',
    saveRunReference: true,
    displayOperations: true,
    onlyDisplayRunsWithOperations: true,
    displayItemLabel: false,
    advancedMode: false,
    defaultSpan: 'last hour',
    defaultRunTypeOption: 'casing,drilling,non_tubular',
    restrictDate: true
}

export const refreshEventName = 'drilling-operations-span-picker-refreshEvent'

export const refreshFunctions = {
    dispatchRefreshEventFormattingDetails: dispatchRefreshEventFormattingDetails,
    updateSpan: updateSpan,
    updateIdentityLookup: updateIdentityLookup,
    getAllTheSpans: getAllTheSpans,
    getMinMaxSpans: getMinMaxSpans,
    getAllTheSpansMinMax: getAllTheSpansMinMax
}

const defaultHeaderContext: headerContextProps = {
    open: false,
    asset: '',
    toggleOpen: () => {},
    setTimespan: () => {},
    setFilters: () => {},
    updateFilter: () => {},
    filterValues: {},
    context: '',
    hasAssetChange: false,
    advancedMode: undefined,
    setAdvancedMode: () => {}
}

export const SpanPickerContext = createContext({
    operationsPickerConfigs: defaultConfigs,
    headerContext: defaultHeaderContext,
    changeSpanPickerConfig: (value: OperationsPickerConfigsProps) => {},
    setOperationsPickerConfigsState: (value: OperationsPickerConfigsProps) => {},
    formattedTree: []
})
